import { ProductUid, RelatedsPageProductsLoad } from '../../domain/models/related-products.models';

// #region PRIVATE
const sliceIdsWithPageSize = (
    allIds: ProductUid[],
    pageSize: RelatedsPageProductsLoad,
    currentPage: number
): ProductUid[] => {
    const startIndex = currentPage * pageSize;
    const endIndex = (currentPage + 1) * pageSize;
    return allIds.slice(startIndex, endIndex);
};
// #endregion PRIVATE

// #region PUBLIC
export const getProductIdsChunkUseCase = (
    itemsIds: ProductUid[],
    pageSize: RelatedsPageProductsLoad,
    currentPage: number
): ProductUid[][] => {
    const currentPageIds = sliceIdsWithPageSize(
        itemsIds,
        pageSize,
        currentPage
    );
    const idsGroups = currentPageIds.reduce((acc, prodUid) => {
        if (acc[prodUid?.relatedType]) {
            acc[prodUid?.relatedType].push(prodUid);
        } else {
            acc[prodUid?.relatedType] = [prodUid];
        }
        return acc;
    }, {});
    return Object.values(idsGroups);
};
// #endregion PUBLIC

// #region __TESTS__
export const __tests__ = {
    sliceIdsWithPageSize,
};
// #endregion __TESTS__
